import React from 'react';

export const Moons = ({ className }) => {
  return (
    <svg viewBox="0 0 290 35" fill="none" className={className}>
      <ellipse cx="17.5186" cy="17.4426" rx="17.5186" ry="17.4426" fill="#FEEBC8" />
      <path
        d="M18.8421 34.7897C15.0882 29.9877 12.8524 23.9513 12.8524 17.3948C12.8524 10.8384 15.0882 4.80195 18.8421 0C27.9075 0.665186 35.0547 8.19897 35.0547 17.3948C35.0547 26.5907 27.9075 34.1245 18.8421 34.7897Z"
        fill="#2A4365"
      />
      <ellipse rx="17.5186" ry="17.4426" transform="matrix(-1 0 0 1 271.536 17.4426)" fill="#FEEBC8" />
      <path
        d="M270.213 34.7897C273.966 29.9877 276.202 23.9513 276.202 17.3948C276.202 10.8384 273.966 4.80195 270.213 0C261.147 0.665186 254 8.19897 254 17.3948C254 26.5907 261.147 34.1245 270.213 34.7897Z"
        fill="#2A4365"
      />
      <ellipse rx="17.5186" ry="17.4426" transform="matrix(-1 0 0 1 102.164 17.4426)" fill="#2A4365" />
      <path
        d="M100.841 34.7897C104.595 29.9877 106.831 23.9513 106.831 17.3948C106.831 10.8384 104.595 4.80195 100.841 0C91.7755 0.665186 84.6282 8.19897 84.6282 17.3948C84.6282 26.5907 91.7755 34.1245 100.841 34.7897Z"
        fill="#FEEBC8"
      />
      <ellipse cx="186.775" cy="17.4426" rx="17.5186" ry="17.4426" fill="#2A4365" />
      <path
        d="M188.099 34.7897C184.345 29.9877 182.109 23.9513 182.109 17.3948C182.109 10.8384 184.345 4.80195 188.099 0C197.164 0.665186 204.311 8.19897 204.311 17.3948C204.311 26.5907 197.164 34.1245 188.099 34.7897Z"
        fill="#FEEBC8"
      />
      <path
        d="M42.3989 17.4426C42.3989 27.0759 50.2082 34.8852 59.8414 34.8852V0C50.2082 0 42.3989 7.80931 42.3989 17.4426Z"
        fill="#FEEBC8"
      />
      <path
        d="M77.284 17.4426C77.284 27.0759 69.4746 34.8852 59.8414 34.8852V0C69.4746 0 77.284 7.80931 77.284 17.4426Z"
        fill="#2A4365"
      />
      <path
        d="M246.541 17.4426C246.541 27.0759 238.731 34.8852 229.098 34.8852V0C238.731 0 246.541 7.80931 246.541 17.4426Z"
        fill="#FEEBC8"
      />
      <path
        d="M211.655 17.4426C211.655 27.0759 219.465 34.8852 229.098 34.8852V0C219.465 0 211.655 7.80931 211.655 17.4426Z"
        fill="#2A4365"
      />
      <circle cx="144.47" cy="17.4426" r="17.4426" fill="#2A4365" />
    </svg>
  );
};
